import React from 'react'
import Header from '../component/Header'
import CommonBanner from '../component/CommonBanner'
import Footer from '../component/Footer'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import UserIcon from '../assets/images/user-your-team.svg'
import LoanIcon from '../assets/images/loan-your-team.svg'
import IconOne from '../assets/images/your-team/1.svg'
import IconTwo from '../assets/images/your-team/2.svg'  
import IconThree from '../assets/images/your-team/3.svg'
import IconFour from '../assets/images/your-team/4.svg'
import IconFive from '../assets/images/your-team/5.svg'
import IconSix from '../assets/images/your-team/6.svg'
import { useNavigate } from 'react-router-dom'

function MyAgents() {
  const navigate = useNavigate();

  const handleConnectWithAgent = () => {
    navigate('/connect-with-an-agent-step');
  };
  return (
    <>
      <div className='main your-team-page'>
        <Header/>
        <CommonBanner title="Your Team" />
        <section className="your-team-section common-padding">
          <Container>
            {/* Header Section */}
            <div className="team-header text-center">
              <h2>Your Team
              </h2>
              <p>
                Build your team through Real Estate - get connected with real estate professionals in your area.
              </p>
            </div>

            {/* Cards Grid */}
            <Row className="g-4">
              {/* Get introduced to a buyer's agent */}
              <Col lg={6} md={12}>
                <Card className="team-card">
                  <Card.Body>
                    <div className='team-card-box'>
                      <div>
                        <h3 className="card-title">Get introduced to a buyer's agent</h3>
                        <p className="card-description">
                          They're your advocate throughout the home shopping journey.
                        </p>
                        <Button className="custom-bttn style-3" onClick={handleConnectWithAgent} >Connect with an agent</Button>
                      </div>
                      <div className="card-icon">
                        <img src={UserIcon} alt="" />
                      </div>
                    </div>
                    <div className="card-info-section">
                      <h4 className="info-title">Get introduced to a buyer's agent</h4>
                      <ul className="info-list">
                        <li>
                          <img src={IconOne} alt="" />
                          <span>Expert in your search area</span>
                        </li>
                        <li>
                          <img src={IconTwo} alt="" />
                          <span>Schedule tours for homes you love</span>
                        </li>
                        <li>
                          <img src={IconThree} alt="" />
                          <span>Help with and negotiate offers</span>
                        </li>
                      </ul>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Connect with a loan officer */}
              <Col lg={6} md={12}>
                <Card className="team-card">
                  <Card.Body>
                    <div className='team-card-box'>
                      <div>
                        <h3 className="card-title">Connect with a loan officer</h3>
                        <p className="card-description">
                          No question is too big or small for the loan officers with Real Estate Home Loans.
                        </p>
                        <Button className="custom-bttn style-3">Get pre-qualified to connect</Button>
                      </div>
                      <div className="card-icon secondary">
                        <img src={LoanIcon} alt="" />
                      </div>
                    </div>
                    <div className="card-info-section">
                      <h4 className="info-title">Questions loan officers can answer</h4>
                      <ul className="info-list">
                        <li>
                          <img src={IconFour} alt="" />
                          <span>What's the mortgage process?</span>
                        </li>
                        <li>
                          <img src={IconFive} alt="" />
                          <span>How do loan options vary by home?</span>
                        </li>
                        <li>
                          <img src={IconSix} alt="" />
                          <span>What affects your qualification?</span>
                        </li>
                      </ul>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section> 
        <Footer />
      </div>
    </>
  )
}
export default MyAgents


